import React from 'react';

import { Button, Card, CardMedia, CardContent, Typography } from '@mui/material';

import {
  CARD_WIDTH,
  MAINTENANCE_IMAGE_URL,
} from '../UnderMaintenance.constants';

export const MaintenanceCard: React.FC = () => {
  return (
    <Card data-testid='maintenance_card' sx={{ width: CARD_WIDTH }}>
      <CardMedia component='img' image={MAINTENANCE_IMAGE_URL} />
      <CardContent>
        <Typography>Сервис временно недоступен. Попробуйте позже.</Typography>
        <Button
          variant='contained'
          sx={{ mt: 2 }}
          onClick={() => globalThis.location.reload()}
        >
          Обновить страницу
        </Button>
      </CardContent>
    </Card>
  );
};
